import { APIS } from '../../../../../lib/constants/apis';
import Schema from '../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

type Dependencies = {
	files: any[];
	relations: any[];
};
function VerwendungsnachweisDependencies() {
	let dependencies: Dependencies = {
		files: [],
		relations: [],
	};

	dependencies.relations.push({ field: P.Verwendungsnachweis_Nachweispositions.path, api: APIS.Nachweisposition });

	return dependencies;
}
export { VerwendungsnachweisDependencies };
